import api from "PFCore/api";
import { PaginatedCollection, Role } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type FetchRolesParams = QueryParams<{
  id?: number[];
  parentActivityId?: number;
  state?: string[];
  workflow_state?: string[];
}>;

export type FetchRolesResponse = PaginatedCollection<{ activity: Role; id: number }[]>;

export const fetchRoles = (params: FetchRolesParams): Promise<FetchRolesResponse> =>
  api({
    url: "roles",
    params
  });

export const fetchAuditRoles = (params: FetchRolesParams): Promise<FetchRolesResponse> =>
  api({
    url: "audit_roles",
    params
  });
